const cartTypes = Object.freeze({
	Cart: 1,
	Wishlist: 2,
})

export { cartTypes }

export default cartTypes
